import React from "react";
import { Alert, AlertTitle } from "@material-ui/lab";

import { withShowIf } from "../../with-show-if/with-show-If.component";

import { ErrorBoxProps } from "../error-box.props";
import { useErrorBoxStyles } from "../error-box.styles";

export const ErrorMessage = withShowIf((props: ErrorBoxProps) => {
  const classes = useErrorBoxStyles();

  return (
    <Alert className={classes.error} severity="error" variant="outlined">
      {!!props.title && props.title !== "" && <AlertTitle>{props.title}</AlertTitle>}
      {props.message}
    </Alert>
  );
});
